import {
  TOGGLE_SELECTOR,
  TOGGLE_CONDITION,
  ADD_CONDITION,
  SUCCESS_SEARCH,
  FAILURE_SEARCH,
  REQUEST_DOWNLOAD,
  SUCCESS_DOWNLOAD,
  REQUEST_SEARCH,
  FAILURE_DOWNLOAD,
  SET_ERROR,
  ErrorAction,
} from '../actions'
import {
  ConditionName,
  AppAction,
  ConditionAction,
  ResultAction,
} from '../actions'

export type AppState = {
  open: boolean
  searching: boolean
  downloading: boolean
  openingCondition: ConditionName | null
}

const init: AppState = {
  open: false,
  searching: false,
  downloading: false,
  openingCondition: null,
}

const toggle = (prev: any, next: any) => (prev === next ? null : next)

export default function app(
  state: AppState = init,
  action: AppAction | ConditionAction | ResultAction | ErrorAction
) {
  switch (action.type) {
    case TOGGLE_SELECTOR:
      return { ...state, open: !state.open }
    case TOGGLE_CONDITION:
      return {
        ...state,
        openingCondition: toggle(state.openingCondition, action.payload),
      }
    case ADD_CONDITION:
      return { ...state, open: false, openingCondition: action.payload }
    case REQUEST_SEARCH:
      return { ...state, searching: true }
    case SUCCESS_SEARCH:
      return { ...state, searching: false }
    case FAILURE_SEARCH:
      return { ...state, searching: false }
    case REQUEST_DOWNLOAD:
      return { ...state, downloading: true }
    case SUCCESS_DOWNLOAD:
      return { ...state, downloading: false }
    case FAILURE_DOWNLOAD:
      return { ...state, downloading: false }
    case SET_ERROR:
      return { ...state, searching: false }
  }
  return state
}
